import FrameInspector from 'components/FrameInspector';
import ErrorOverlay from 'components/Widget/Overlay/ErrorOverlay';
import LoadingOverlay from 'components/Widget/Overlay/LoadingOverlay';
import { FrameAccessResponse } from 'dragonmouse-shared/api/forge';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import forge from '../../apis/forge';
import * as routes from '../../routes';
import { selectIsMobile } from 'redux/mode/reducers';
import { shallowEqual } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { useSelector } from 'react-redux';
import FrameGallery from 'components/FrameGallery';

function StandaloneFrameViewer() {
	const params = useParams();
	const { isMobile } = useSelector((r: RootReducer) => {
		return {
			isMobile: selectIsMobile(r.mode),
		};
	}, shallowEqual);

	const frameId = params.frameId;
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true);
	const [isPubliclyReadable, setIsPubliclyReadable] = useState(false);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const checkFrameAccess = async () => {
			try {
				if (!frameId) {
					setError('No frame ID provided');
					return;
				}

				setIsLoading(true);
				setError(null);

				const response: FrameAccessResponse = await forge.accessFrame({ frameId });
				if (response.sceneId) {
					// User has scene access, redirect to project URL
					const sceneId = response.sceneId;
					const sceneTitle = 'Placeholder';
					const projectUrl = routes.frame(sceneId, sceneTitle, frameId, { edit: 'false' });
					navigate(projectUrl);
				} else if (response.publiclyReadable) {
					setIsPubliclyReadable(true);
				} else {
					setError('You do not have permission to view this prototype');
				}
			} catch (err: any) {
				setError('You do not have permission to view this prototype');
			} finally {
				setIsLoading(false);
			}
		};

		checkFrameAccess();
	}, [frameId, navigate]);

	if (isLoading) {
		return <LoadingOverlay />;
	}

	if (error) {
		return <ErrorOverlay text={error} showProjectsLink />;
	}

	if (frameId && isPubliclyReadable) {
		return isMobile ? <FrameGallery frameId={frameId} /> : <FrameInspector frameId={frameId} />;
	}

	return null;
}

export default StandaloneFrameViewer;
